import { styled } from '@stitches/configed';
import { LoadingIcon } from '..';

const Container = styled('div', {
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});
const PageLoading = () => {
  return (
    <>
      <Container>
        <LoadingIcon />
      </Container>
    </>
  );
};

export default PageLoading;
